"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectTenant = void 0;
const react_1 = __importDefault(require("react"));
const moment_1 = __importDefault(require("moment"));
const styled_components_1 = __importStar(require("styled-components"));
const ModalWrapper_1 = require("./ModalWrapper");
const ZGridList_1 = require("../../components/ZGridList/ZGridList");
const utils_1 = require("../../utils/utils");
const useAuth0_1 = require("../hooks/useAuth0");
const useGetTenants_1 = require("../hooks/useGetTenants");
//#region Styles
const NoTenants = styled_components_1.default((props) => (react_1.default.createElement("span", { className: props.className }, "The account entered does not have access to tenants."))) `
   color: ${props => props.theme["alert-color"]};
   padding: 7px;
   width: calc(100% - 14px);
   text-align: center;
   position: relative;
   top: 5vh;
   display: block;
`;
const TenantBody = styled_components_1.default.div `
   width: 100%;
   height: 300px;
   background-color: #fff;
`;
const TenantHeader = styled_components_1.default.div `
   background: linear-gradient(to right, #eaeaea, #d2d2d2, #eaeaea);
   border-radius: 5px 5px 0 0;
   padding: 11px;
   width: calc(100% - 22px);
   text-align: center;
   height: 99px;
`;
const TenantHeaderTitle = styled_components_1.default.div `
   font-size: 22px;
   color: #333;
   font-weight: normal;
   line-height: 30px;
   padding-bottom: 3px;
   font-family: ${props => props.theme["font-family"]};
`;
const TenantHeaderImg = styled_components_1.default.img.attrs(props => ({
    alt: "Tenant Logo",
    src: props.src
})) `
   width: 100% - 2px;
   height: 58px;
   margin-bottom: 11px;
   vertical-align: middle;
`;
const TenantSelectText = styled_components_1.default.span `
   color: #fff;
   letter-spacing: 1px;
   text-transform: uppercase;
   height: 42px;
   line-height: 42px;
   cursor: pointer;
   font: inherit;
   transition: 0.2s ease-in-out;

   .select-tenant-arrow {
      position: relative;
      top: 1px;
   }
`;
const TenantSelectBtn = styled_components_1.default.button `
   cursor: pointer;
   background-color: ${props => props.theme["app-link-color"]};
   display: block;
   border: 0;
   position: relative;
   left: -1px;
   width: calc(100% + 2px);
   color: #fff;
   font-family: ${props => props.theme["font-family"]};
   border-radius: 0 0 5px 5px;
   padding: 14px;
   height: 70px;

   span {
      font-size: 1em;
      transition: all 250ms ease;
   }

   :hover {
      background-color: ${props => props.theme["hover-color"]};
      span {
         font-size: 1.05em;
      }
   }

   :active {
      background-color: ${props => props.theme["active-color"]};
   }
`;
const getTenant = (idx) => document.querySelector(`tbody > tr:nth-child(${idx})`), getTenants = () => document.querySelectorAll("tbody > tr"), getSelectedTenant = () => document.querySelector("tbody > tr.k-state-selected"), getIdxFromEl = (el) => {
    if (el === null) {
        return null;
    }
    let element = el;
    if ("tagName" in el && el.tagName === "TR") {
        element = el && el.firstElementChild;
    }
    if (element === null) {
        return null;
    }
    const tenants = getTenants();
    if (tenants.length > 0) {
        let ret = -1;
        tenants.forEach((tr, idx) => {
            const td = tr && tr.firstElementChild;
            if (td && td.id === element.id) {
                ret = idx;
            }
        });
        return ret === -1 ? null : ret + 1;
    }
    return null;
}, select = (idx) => {
    const tr = getTenant(idx);
    const trs = getTenants();
    if (tr === null) {
        return null;
    }
    trs.forEach(t => t.classList.contains("k-state-selected") &&
        t.classList.remove("k-state-selected"));
    if (!tr.classList.contains("k-state-selected")) {
        tr.classList.add("k-state-selected");
    }
    if (tr.classList.contains("k-alt")) {
        tr.classList.remove("k-alt");
    }
    return idx;
}, unselect = (idx) => {
    const tr = getTenant(idx);
    if (tr !== null && tr.classList.contains("k-state-selected")) {
        tr.classList.remove("k-state-selected");
    }
}, getSelectedId = () => {
    const selectedTenant = getSelectedTenant();
    const td = selectedTenant && selectedTenant.firstElementChild;
    if (td === null) {
        return null;
    }
    const id = parseInt(td.id);
    return isNaN(id) ? null : id;
}, getSelectedIdx = () => {
    const selectedTenant = getSelectedTenant(), selectedIdx = getIdxFromEl(selectedTenant);
    return selectedIdx;
}, getLastIdx = () => getTenants().length - 1, handleGridItemClick = (ev) => {
    const tarIdx = getIdxFromEl(ev.currentTarget), curIdx = getSelectedIdx();
    if (tarIdx === null) {
        return;
    }
    if (curIdx !== null) {
        unselect(curIdx);
    }
    select(tarIdx);
}, scrollIdxIntoView = (idx) => {
    if (idx !== null) {
        const tenant = getTenant(idx);
        if (tenant !== null) {
            //@ts-ignore
            tenant.scrollIntoViewIfNeeded();
        }
    }
}, Symbol = ({ forward }) => (react_1.default.createElement("svg", { focusable: "false", className: "select-tenant-arrow", width: "8px", height: "12px", style: {
        transformBox: "fill-box",
        transformOrigin: "center",
        transform: `rotate(${forward ? 0 : "180deg"})`
    } },
    react_1.default.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
        react_1.default.createElement("g", { transform: "translate(-148.000000, -32.000000)", fill: "#FFFFFF" },
            react_1.default.createElement("polygon", { points: "148 33.4 149.4 32 155.4 38 149.4 44 148 42.6 152.6 38" }))))), getButtonText = (hasTenants) => (react_1.default.createElement(react_1.default.Fragment, null,
    hasTenants ? react_1.default.createElement("span", null, "Select Tenant ") : null,
    react_1.default.createElement(Symbol, { forward: hasTenants }),
    hasTenants ? null : react_1.default.createElement("span", null, " Return"))), getHash = (authResult) => {
    let hash = document.location.hash;
    if (hash.includes("error=") || hash.includes("error_description=")) {
        const error = hash
            .substring(hash.indexOf("error="), hash.indexOf("&", hash.indexOf("error=")))
            .split("=")[1];
        const descr = hash
            .substring(hash.indexOf("error_description="), hash.indexOf("&", hash.indexOf("error_description=")))
            .split("=")[1];
        document.location.replace(`/Login#error=${error}&error_description=${descr}`);
    }
    if ((hash.trim() === "" || hash.trim() === "#") &&
        authResult &&
        authResult.accessToken !== undefined) {
        const accessToken = `#access_token=${authResult.accessToken}`;
        const idToken = `&id_token=${authResult.idToken}`;
        const expiresIn = `&expires_in=${authResult.expiresIn}`;
        const tokenType = `&token_type=${authResult.tokenType}`;
        const state = `&state=${authResult.state}`;
        return `${accessToken}${idToken}${expiresIn}${tokenType}${state}`;
    }
    return hash;
}, getJWTPayload = (token) => utils_1.base64Decode(token.split(".")[1]);
exports.SelectTenant = (props) => {
    const { getTenantsEndpoint, redirectToSlug, handleAuth0Error, handleAuth0Profile, handleAuth0Result, onTenantSelect, onReturn, clientId } = props, { lock } = useAuth0_1.useAuthContext(), [authTokenState, setAuthTokenState] = react_1.default.useState(""), [fetchedUserInfo, setFetchedUserInfo] = react_1.default.useState(false), authToken = react_1.default.useMemo(() => {
        const lsAuthResult = localStorage.getItem("authResult"), lsIDSToken = localStorage.getItem("IDSBearer");
        if (authTokenState) {
            return authTokenState;
        }
        else if (lsAuthResult) {
            const authResultJSON = JSON.parse(lsAuthResult);
            return authResultJSON.accessToken;
        }
        else if (lsIDSToken) {
            return lsIDSToken;
        }
        return "";
    }, [authTokenState]), getAuthResult = () => {
        const lsAuthResult = localStorage.getItem("authResult") || "{}";
        return JSON.parse(lsAuthResult);
    }, [resumingAuth, setResumingAuth] = react_1.default.useState(false), { loading, tenants, error } = useGetTenants_1.useGetTenants(getTenantsEndpoint, authToken, clientId), hasTenants = react_1.default.useMemo(() => tenants.length > 0, [tenants]), theme = react_1.default.useContext(styled_components_1.ThemeContext), handleOnReturn = (e) => onReturn && onReturn(), redirect = react_1.default.useCallback(() => document.location.assign(redirectToSlug), [redirectToSlug]), handleTenantSelect = (e) => {
        const id = getSelectedId();
        if (id !== null) {
            localStorage.setItem("Company-Id", id.toString());
            localStorage.setItem("numOfCompanies", `${tenants.length}`);
            onTenantSelect && onTenantSelect();
            redirect();
        }
    }, handleKeyPressed = (ev) => {
        const currIdx = getSelectedIdx();
        const lastIdx = getLastIdx();
        switch (ev.key) {
            case "Enter":
                handleTenantSelect();
                break;
            case "ArrowUp":
                if (currIdx !== null && currIdx > 1) {
                    unselect(currIdx);
                    select(currIdx - 1);
                    scrollIdxIntoView(currIdx - 1);
                }
                break;
            case "ArrowDown":
                if (currIdx !== null && currIdx <= lastIdx) {
                    unselect(currIdx);
                    select(currIdx + 1);
                    scrollIdxIntoView(currIdx + 1);
                }
                break;
            default:
                break;
        }
    }, tenantTemplate = styled_components_1.default((props) => {
        const timeFromNow = props.dataItem.LastLoggedIn === "0001-01-01T00:00:00Z"
            ? "---"
            : moment_1.default.utc(props.dataItem.LastLoggedIn).fromNow();
        return (react_1.default.createElement("td", { id: props.dataItem.Id.toString(), className: props.className, onClick: handleGridItemClick, onDoubleClick: handleTenantSelect },
            react_1.default.createElement("span", { className: "tenant-name" }, props.dataItem.Name),
            react_1.default.createElement("span", { className: "tenant-from-now" }, timeFromNow)));
    }) `
         user-select: none;

         :hover {
            color: #fff;
            background-color: ${props => props.theme["hover-color"]};
            @media (pointer: coarse) {
               background-color: ${props => props.theme["selected-background-color"]};
            }
         }

         :active {
            color: #fff;
            background-color: ${props => props.theme["active-color"]};
            @media (pointer: coarse) {
               background-color: ${props => props.theme["selected-background-color"]};
            }
         }

         .tenant-name {
            font-size: 14px;
            float: left;
         }

         .tenant-from-now {
            font-size: x-small;
            float: right;
         }
      `, Tenants = styled_components_1.default((props) => (react_1.default.createElement(ZGridList_1.ZGridList, { className: props.className, selectedField: "selected", cell: tenantTemplate, data: props.data, scrollable: "scrollable", take: props.data && props.data.length, pending: props.pending }))) `
         .k-grid {
            height: 300px;
         }

         .k-widget {
            border-width: 0px;
            border-style: none;
         }

         .selected {
            background-color: ${props => props.theme["selected-background-color"]} !important;
            color: #fff !important;
         }

         .k-grid-content tr:last-child td {
            border-bottom-width: 1px;
         }

         tbody {
            cursor: pointer;
         }

         td {
            padding-left: 13px !important;
            padding-right: 13px !important;
            padding-top: 5px !important;
            padding-bottom: 5px !important;
         }

         .k-grid-norecords {
            display: none;
         }

         .k-loading-image {
            top: -25px;
         }

         width: 100%;
         text-align: center;
         max-height: 300px;
         min-height: 300px;
      `;
    react_1.default.useEffect(() => {
        if (!localStorage.getItem("Company-Id")) {
            const authResult = getAuthResult(), hash = getHash(authResult);
            if (!resumingAuth && hash.trim() !== "" && hash.trim() !== "#") {
                setResumingAuth(true);
                lock.resumeAuth(hash, (err, res) => {
                    if (err && res === undefined) {
                        handleAuth0Error && handleAuth0Error(err);
                    }
                    else if (res !== undefined) {
                        const accessTokenPayload = getJWTPayload(res.accessToken);
                        res["accessTokenPayload"] = JSON.parse(accessTokenPayload);
                        if (handleAuth0Result) {
                            handleAuth0Result(res);
                        }
                        setAuthTokenState(res.accessToken);
                        localStorage.setItem("authResult", JSON.stringify(res));
                        lock.getUserInfo(res.accessToken, (err, prof) => {
                            if (err && prof === undefined) {
                                handleAuth0Error && handleAuth0Error(err);
                            }
                            else if (prof !== undefined) {
                                handleAuth0Profile && handleAuth0Profile(prof);
                            }
                            else {
                                handleAuth0Error && handleAuth0Error(err);
                            }
                            setFetchedUserInfo(true);
                        });
                    }
                    else {
                        handleAuth0Error && handleAuth0Error(err);
                    }
                });
            }
            else if (authResult !== null && authResult.accessToken) {
                const lsAuthProfile = localStorage.getItem("authProfile");
                if (!lsAuthProfile) {
                    lock.getUserInfo(authResult.accessToken, (err, prof) => {
                        if (err && prof === undefined) {
                            handleAuth0Error && handleAuth0Error(err);
                        }
                        else if (prof !== undefined) {
                            handleAuth0Profile && handleAuth0Profile(prof);
                        }
                        else {
                            handleAuth0Error && handleAuth0Error(err);
                        }
                        setFetchedUserInfo(true);
                    });
                }
            }
            else {
                !resumingAuth && redirect();
            }
        }
    }, [
        handleAuth0Error,
        handleAuth0Profile,
        handleAuth0Result,
        lock,
        redirect,
        resumingAuth
    ]);
    react_1.default.useEffect(() => {
        if (!loading) {
            if (error) {
                const err = error.message.split("|")[0];
                const errd = error.message.split("|")[1];
                localStorage.clear();
                document.location.href = `/Login#error=${err}&error_description=${errd}`;
            }
            if (tenants.length === 1 && fetchedUserInfo) {
                const selected = tenants[0];
                localStorage.setItem("Company-Id", selected.Id.toString());
                localStorage.setItem("numOfCompanies", "1");
                redirect();
            }
            else {
                select(1);
            }
        }
    }, [redirect, tenants, loading, error, fetchedUserInfo]);
    react_1.default.useEffect(() => {
        window.addEventListener("keydown", handleKeyPressed);
        return () => window.removeEventListener("keydown", handleKeyPressed);
    });
    return (react_1.default.createElement(ModalWrapper_1.ModalWrapper, { style: { top: 0 } },
        react_1.default.createElement(TenantHeader, null,
            react_1.default.createElement(TenantHeaderImg, { src: theme["app-logo-color-url"] }),
            react_1.default.createElement(TenantHeaderTitle, null, "Select Tenant")),
        react_1.default.createElement(TenantBody, null, loading || hasTenants ? (react_1.default.createElement(Tenants, { data: tenants, pending: loading })) : (react_1.default.createElement(NoTenants, null))),
        react_1.default.createElement(TenantSelectBtn, { onClick: hasTenants ? handleTenantSelect : handleOnReturn },
            react_1.default.createElement(TenantSelectText, null, getButtonText(hasTenants)))));
};
//# sourceMappingURL=SelectTenant.js.map